<template>
  <div
    v-if="message"
    :class="['sealed-unit-overbooked-chip', statusClass]"
  >
    <v-icon
      small
      class="sealed-unit-overbooked-chip__icon"
    >
      {{ statusIcon }}
    </v-icon>
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'SealedUnitOverbookingStatusChip',
  props: {
    message: {
      type: String,
      default: '',
    },
    checking: {
      type: Boolean,
      default: false,
    },
    overbooked: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    statusClass() {
      if (this.checking) return 'sealed-unit-overbooked-chip--checking';
      if (this.overbooked) return 'sealed-unit-overbooked-chip--overbooked';
      if (this.checked) return 'sealed-unit-overbooked-chip--available';
      return '';
    },
    statusIcon() {
      if (this.checking) return 'mdi-timer-sand';
      if (this.overbooked) return 'mdi-alert-circle';
      return 'mdi-check-circle';
    },
  },
};
</script>

<style scoped>
.sealed-unit-overbooked-chip {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 8px 12px;
  border-radius: 12px;
  background-color: rgba(244, 67, 54, 0.12);
  color: #B71C1C;
}

.sealed-unit-overbooked-chip--checking {
  justify-content: center;
  width: calc(100% - 32px);
  box-sizing: border-box;
  background-color: rgba(251, 191, 36, 0.16);
  color: #92400E;
}

.sealed-unit-overbooked-chip--overbooked {
  background-color: rgba(244, 67, 54, 0.12);
  color: #B71C1C;
}

.sealed-unit-overbooked-chip--available {
  justify-content: center;
  width: calc(100% - 32px);
  box-sizing: border-box;
  background-color: rgba(76, 175, 80, 0.14);
  color: #1B5E20;
}

.sealed-unit-overbooked-chip__icon {
  margin-right: 6px;
  font-size: 20px !important;
  color: #B71C1C !important;
}

.sealed-unit-overbooked-chip--checking .sealed-unit-overbooked-chip__icon {
  color: #92400E !important;
}

.sealed-unit-overbooked-chip--overbooked .sealed-unit-overbooked-chip__icon {
  color: #B71C1C !important;
}

.sealed-unit-overbooked-chip--available .sealed-unit-overbooked-chip__icon {
  color: #1B5E20 !important;
}

.sealed-unit-overbooked-chip span {
  font-size: 14px !important;
  font-weight: 700;
}
</style>
